// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  State,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  componentKey: __t.string().name("component_key"),
  day: __t.string(),
  okCount: __t.u32().name("ok_count"),
  failCount: __t.u32().name("fail_count"),
  get worstState() {
    return State.name("worst_state");
  },
});
